export default __webpack_public_path__ + "static/media/our-team-6.738224d6.jpg";